import { module } from 'angular';
import App from '../../../app';

class SCR1802Controller {
	
	constructor ($scope, $state, $timeout, $uibModalInstance, httpService, utilService, gridService, popupService, data){
		this.$scope = $scope;
		this.$state = $state;
		this.$timeout = $timeout;
		this.$uibModalInstance = $uibModalInstance;
		this.httpService = httpService;
		this.utilService = utilService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.data = data;
		
		this.initWindow(750, 700);
		this.initText();
		this.initSearch();
		this.initSelect();
		
		this.$timeout(() => {
			this.initIntrfcGridOption();
			this.initGetEffectsList();
		});
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = {
			metaEngNm : bxMsg('manageMetaInfo.metaEngNm'),
			metaKorNm : bxMsg('manageMetaInfo.metaKorNm'),
			metaLen : bxMsg('manageMetaInfo.metaLen'),
			decimalLen : bxMsg('manageMetaInfo.decimalLen'),
			dataTypeNm : bxMsg('manageMetaInfo.dataTypeNm'),
			influenceModal : bxMsg('manageMetaInfo.influenceModal'),
			intrfcId : bxMsg('manageMetaInfo.intrfcId'),
			intrfcNm : bxMsg('manageMetaInfo.intrfcNm'),
			intrfcType : bxMsg('manageMetaInfo.intrfcType'),
			msgId : bxMsg('manageMetaInfo.msgLayoutId'),
			alertConfirm : bxMsg('common.alertConfirm'),
			confirmOk : bxMsg('common.confirmOk'),
			confirmCancel : bxMsg('common.confirmCancel'),
			showDetail: bxMsg('common.showDetail'),
			search : bxMsg('common.search'),
			resetSearch : bxMsg('common.resetSearch'),
			close : bxMsg('common.close'),
			interfaceTitle1 : bxMsg('manageMciInterface.titleHeader'),
			interfaceTitle2 : bxMsg('manageFepInterface.titleHeader'),
			interfaceTitle3 : bxMsg('manageEaiInterface.titleHeader'),
			interfaceTitle4 : bxMsg('manageEaiInterface.titleHeader2'),
			interfaceTitle5 : bxMsg('manageEaiInterface.titleHeader3')
		};
	}
	
	initSearch(){
		this.searchParam = {};
	}
	
	initSelect(){
		this.select = this.gridService.getSelect(10);
	}
	
	initIntrfcGridOption(){
		this.gridView = new RealGridJS.GridView('grid');
		this.dataProvider = new RealGridJS.LocalDataProvider();
		this.gridView.setDataSource(this.dataProvider);		
		this.gridService.setDefaultSetting(this.gridView);
		this.gridView.setCheckBar({visible: false});
		this.gridView.setDisplayOptions({fitStyle: 'evenFill', vscrollBar: true}); 
		
		this.dataProvider.setFields([
            {
            	fieldName: "no",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.gridService.getNoField(this.select.pageSize, dataRow, this.pageNumber);
        		}
    		}, 
    		 {fieldName: "intrfcId"}, {fieldName: "intrfcNm"}, {fieldName: "intrfcType"}, {fieldName: "msgLayoutId"}
        ]);
		
		this.gridView.setColumns([
			{ name: "no", fieldName: "no", header : { text: "No" } , width: 40, styles: { textAlignment: 'center' } },
			{ name: "intrfcId", fieldName: "intrfcId", header : { text: this.text.intrfcId }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "intrfcNm", fieldName: "intrfcNm", header : { text: this.text.intrfcNm }, width: 100, styles: { textWrap: 'ellipse' } },
			{ name: "intrfcType", fieldName: "intrfcType", header : { text: this.text.dataTypeNm }, width: 40, styles: { textAlignment: 'center' } },
			{ name: "msgLayoutId", fieldName: "msgLayoutId", header : { text: this.text.msgId }, width: 100, styles: { textAlignment: 'center' } },
			{ 
				name: "buttonColumn", fieldName: "buttonColumn", button: 'image', buttonVisibility: 'always', header : { text: this.text.showDetail }, width: 40, cursor: 'pointer',
				renderer: {
					type: 'imageButtons',
					alignment: 'center',
					images: [{
						name: 'more',
						up: './assets/images/grid/detail.png',
						width: 20
					}]
				}
			}
		]);
		
		this.gridView.onImageButtonClicked = (grid, itemIndex, column, buttonIndx, name) => {
			this.openTab(grid.getValues(itemIndex));
		};
		
		this.gridView.onDataCellDblClicked = (grid, cell) => {
			this.openTab(grid.getValues(cell.itemIndex));
		};
	}
	
	openTab(record){
		let state;
		
		if(record.intrfcType === 'MCI') {
			state = 'main.manageMciInterface';
		}else if(record.intrfcType === 'EAI_I') {
			state = 'main.manageEaiInterface';
		}else if(record.intrfcType === 'FEP') {
			state = 'main.manageFepInterface';
		}else if(record.intrfcType === 'EAI_E') {
			state = 'main.manageEaiInterface2';
		}else if(record.intrfcType === 'CC') {
			state = 'main.manageCcInterface';
		}
		
		this.utilService.openTab(this.$scope, {
			state: state
		}, {
			data: {
				intrfcId: record.intrfcId,
				msgLayoutId: record.msgLayoutId,
				delYN: 'N'
			}
		}, 'main.manageMsg');
	}
	
	initGetEffectsList(){
		const data = this.data;
		
		if(_.isEmpty(data)){
			this.getEffectList = this.getMetaEffectedInterfaceList;
		} else {
			if(this.data.metaEngNm) this.getEffectList = this.getMetaEffectedInterfaceList;
			else if(data.msgLayoutId) this.getEffectList = this.getMsglayoutEffectedInterfaceList;
			else this.getEffectList = this.getMetaEffectedInterfaceList;
		}
		
		this.getEffectList();
	}
	
	getMetaEffectedInterfaceList(){
		let url = `/metas/effects?metaEngNm=${this.data.metaEngNm}`;
		
		this.httpService.get(url, this.searchParam).then(data => {
			this.dataProvider.setRows(data);
		});
	}
	
	getMsglayoutEffectedInterfaceList(){
		let encodedId = encodeURIComponent(this.data.msgLayoutId);
		let url = `/msglayouts/${encodedId}/effects?`;
		
		this.httpService.get(url, this.searchParam).then(data => {
			this.dataProvider.setRows(data);
		});
	}
	
	resetSearch(){
		this.searchParam = {};
		this.getEffectList(true);
	}
	
	search(){
		this.getEffectList(true);
	}
	
	blur($event){
		$event.target.blur();
	}
	
	closeModal(isOk){
		if(isOk){
			const selection = this.gridView.getSelectedRows();
			
			if(selection.length === 0){
				this.$uibModalInstance.dismiss();
			} else {
				this.$uibModalInstance.close(this.gridView.getValues(selection[0]));
			}
		} else {
			this.$uibModalInstance.dismiss();
		}
		
		this.gridView.destroy();
		this.dataProvider.destroy();
	}
}

module(App.name).controller('SCR1802Controller', SCR1802Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR1802/SCR1802.controller.js